module.exports = __webpack_public_path__ + "static/media/banner-home-2.7b1c1ffb.jpg";